// frontend/src/pages/ProjectOpex.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";

export default function ProjectOpex() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;
  
  return (
    <form className="max-w-md space-y-8 text-xs">
      <div className="space-y-2">
        <ProjectInputField label="Land or roof lease (EUR/kWp p.a.)" name="roof_land_lease" value={formData.roof_land_lease} onChange={handleChange} />
        <ProjectInputField label="Lease duration (years)" name="lease_duration" value={formData.lease_duration} onChange={handleChange} />
        <ProjectInputField label="Lease payment after first term (% of sales p.a.)" name="lease_after_first_term" value={formData.lease_after_first_term} type={getFieldType("lease_after_first_term")} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label="Operations & maintenance fee (EUR/kWp p.a)" name="operations_and_maintenance_fee" value={formData.operations_and_maintenance_fee} onChange={handleChange} />
        <ProjectInputField label="Direct marketing costs (EUR/kWp p.a.)" name="direct_marketing_costs" value={formData.direct_marketing_costs} onChange={handleChange} />
        <ProjectInputField label="Insurance costs (EUR/kWp p.a.)" name="insurance_costs" value={formData.insurance_costs} onChange={handleChange} />
        <ProjectInputField label="Land or roof maintenance (EUR/kWp p.a.)" name="land_or_roof_maintenance" value={formData.land_or_roof_maintenance} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label="Other fixed OpEx (EUR/kWp p.a.)" name="other_fixed_opex" value={formData.other_fixed_opex} onChange={handleChange} />
        <ProjectInputField label="Other variable OpEx (EUR/kWh p.a.)" name="other_variable_opex" value={formData.other_variable_opex} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label="Management fee (% p.a. of total investment)" name="management_fee" value={formData.management_fee} type={getFieldType("management_fee")} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label="Inflation rate for costs (% p.a.)" name="inflation_rate_for_costs" value={formData.inflation_rate_for_costs} type={getFieldType("inflation_rate_for_costs")} onChange={handleChange} />
        <ProjectInputField label="Cost share 1st year" name="cost_share_1st_year" value={formData.cost_share_1st_year} type={getFieldType("cost_share_1st_year")} onChange={handleChange} />
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}